<template>
  <div>
    <!-- 箱规修改 -->
    <el-dialog :title="$t('message.boxGaugeModification')" :close-on-click-modal="false"
      :visible.sync="$parent.boxGaugeModificationDialogVisible" width="725px" center>
      <div class="content">
        <div class="table">
          <ol>
            <!-- 箱型 -->
            <li class="flex15">
              {{ $t("message.boxPile") }}
            </li>
            <!-- 长 -->
            <li>
              {{ $t("message.length") }}.cm
            </li>
            <!-- 箱宽型 -->
            <li>
              {{ $t("message.width") }}.cm
            </li>
            <!-- 高 -->
            <li>
              {{ $t("message.height") }}.cm
            </li>
          </ol>
          <ul>
            <!-- 箱型 -->
            <li class="flex15">
              <el-select v-model="attr" placeholder="请选择" @change="setCWK">
                <el-option v-for="item in attrOption" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </li>
            <!-- 长 -->
            <li>
              <el-input v-model="c" type="number" onfocus="this.select()"></el-input>
            </li>
            <!-- 箱宽型 -->
            <li>
              <el-input v-model="k" type="number" onfocus="this.select()"></el-input>
            </li>
            <!-- 高 -->
            <li>
              <el-input v-model="g" type="number" onfocus="this.select()"></el-input>
            </li>
          </ul>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <!--取 消  -->
        <!-- <el-button @click="$parent.boxGaugeModificationDialogVisible = false">{{
          $t("message.cancel")
        }}</el-button> -->
        <!-- 保存 -->
        <el-button type="primary" @click="save">{{
          $t("message.ok")
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { attrOption } from "@/utlis/options";
export default {
  props: {
    ids: { type: Array },
  },
  data() {
    return {
      num: "",
      attr: "",
      c: "",
      k: "",
      g: "",
      attrOption,
    };
  },
  created() { },
  methods: {
    // 保存
    save() {
      let datas = {
        ids: this.ids,
        attr: `${this.c}*${this.k}*${this.g}`,
        c: this.c,
        k: this.k,
        g: this.g,
      };

      if (this.c == "") return this.$message.error("请输入箱子的长");
      if (this.k == "") return this.$message.error("请输入箱子的宽");
      if (this.g == "") return this.$message.error("请输入箱子的高");
      this.$api.inspectionApi.updateBoxAttr(datas).then((res) => {
        this.$message.success(res.msg);
        this.$parent.boxGaugeModificationDialogVisible = false;
        this.$parent.uploadBoxList();
      });
    },
    // 取到长宽高
    setCWK(e) {
      let arr = e.split("*");
      this.c = arr[0];
      this.k = arr[1];
      this.g = arr[2];
    },
  },
};
</script>
<style lang='scss' scoped>
.content {
  margin: 0px 15px;

  .table {
    border: 1px solid #edeff4;

    ol {
      display: flex;
    }

    ul {
      display: flex;
      padding: 0;
      border: 0;

      li {
        padding: 24px 0;
      }
    }

    li {
      border-right: 1px solid #edeff4;

      &:nth-last-child(1) {
        border: 0;
      }
    }

    .flex15 {
      flex: 1.5;
    }
  }

  /deep/.el-input {
    width: 60%;
  }

  /deep/.el-select {
    .el-input {
      width: 100%;
    }

    width: 80%;
  }
}
</style>